
	$(document).ready(function() {


		$('.minus').click(function () {
			var $input = $(this).parent().find('input');
			var count = parseInt($input.val()) - 1;
			count = count < 0 ? 0 : count;
			$input.val(count);
			$input.change();
			return false;
		});
		
		$('.plus').click(function () {
			var $input = $(this).parent().find('input');
			$input.val(parseInt($input.val()) + 1);
			$input.change();
			return false;
		});


});
	

$(document).ready(function(){



	$('.search').on('click',function(){
      if(window.innerWidth >= 768) {	
      	$('.sub-search').slideToggle();
        $('#bc-sf-search-box-0').focus();
      }
      return false;
	});

     $('.responsive_nav_bar').click(function(){
       $('.responsive-menu').toggleClass('canvas-menu');
       $('body').toggleClass("overflow-hidden");
       return false;
	});

     // product Carousel 

		// Client Review 
	


     // basic code
     $(".card-header a").click(function(){
     	$('.card-header a').removeClass('hello');
     	$(this).addClass('hello');
     })
     
      $.scrollIt({
        upKey: 38,                // key code to navigate to the next section
        downKey: 40,              // key code to navigate to the previous section
        easing: 'swing',         // the easing function for animation
        scrollTime: 1300,          // how long (in ms) the animation takes
        activeClass: 'active',    // class given to the active nav element
        onPageChange: null,       // function(pageIndex) that is called when page is changed
        topOffset: -0            // offste (in px) for fixed top navigation
  });


});	


jQuery(function(){
  var j = jQuery; //Just a variable for using jQuery without conflicts
  var addInput = '#qty'; //This is the id of the input you are changing
  var n = 1; //n is equal to 1
  
  //Set default value to n (n = 1)
  j(addInput).val(n);

  //On click add 1 to n
  j('.plus').on('click', function(){
    j(addInput).val(++n);
  })

  j('.min').on('click', function(){
    //If n is bigger or equal to 1 subtract 1 from n
    if (n >= 1) {
      j(addInput).val(--n);
    } else {
      //Otherwise do nothing
    }
  });
});




	